import React from "react";
import { Star, Quote } from "lucide-react";
import "../styles/Feedback/Feedback.css";

export function Feedback() {
  const feedbacks = [
    {
      id: 1,
      name: "Priya Sharma",
      location: "Mumbai",
      service: "Home Cleaning",
      rating: 5,
      review:
        "Absolutely fantastic service! The cleaning team was professional, punctual, and thorough. My home has never looked better. The eco-friendly products they used were a bonus. Highly recommend!",
      avatar:
        "https://images.unsplash.com/photo-1633613286991-611fe299c4be?ixlib=rb-4.1.0&q=80&w=1080",
      verified: true,
    },
    {
      id: 2,
      name: "Rajesh Kumar",
      location: "Delhi",
      service: "Plumbing",
      rating: 5,
      review:
        "Quick response and excellent workmanship. The plumber arrived within 2 hours of booking and fixed my leaking tap perfectly. Fair pricing and professional service. Will definitely use again.",
      avatar:
        "https://images.unsplash.com/photo-1633613286991-611fe299c4be?ixlib=rb-4.1.0&q=80&w=1080",
      verified: true,
    },
    {
      id: 3,
      name: "Anita Patel",
      location: "Bangalore",
      service: "Beauty & Spa",
      rating: 5,
      review:
        "Amazing spa experience at home! The therapist was skilled and professional. The massage was relaxing and rejuvenating. It felt like being at a luxury spa. Great value for money.",
      avatar:
        "https://images.unsplash.com/photo-1633613286991-611fe299c4be?ixlib=rb-4.1.0&q=80&w=1080",
      verified: true,
    },
    {
      id: 4,
      name: "Anita Patel",
      location: "Bangalore",
      service: "Beauty & Spa",
      rating: 5,
      review:
        "Amazing spa experience at home! The therapist was skilled and professional. The massage was relaxing and rejuvenating. It felt like being at a luxury spa. Great value for money.",
      avatar:
        "https://images.unsplash.com/photo-1633613286991-611fe299c4be?ixlib=rb-4.1.0&q=80&w=1080",
      verified: true,
    },
  ];

  return (
    <section className="feedback-section">
      <div className="container">
        <div className="heading">
          <h2>Customer Feedback</h2>
          <p>
            Over 100,000 satisfied customers trust us for their home service
            needs. Here’s what they have to say about their experience.
          </p>
        </div>

        <div className="carousel">
          {feedbacks.map((f) => (
            <div key={f.id} className="carousel-item">
              <div className="quote-row">
                <Quote className="quote-icon" />
                {f.verified && <span className="badge">Verified</span>}
              </div>

              <p className="review-text">"{f.review}"</p>

              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`star-icon ${i < f.rating ? "filled" : "empty"}`}
                  />
                ))}
              </div>

              <div className="avatar-container">
                <img src={f.avatar} alt={f.name} className="avatar" />
                <div className="customer-info">
                  <div className="customer-name">{f.name}</div>
                  <div className="customer-location">{f.location}</div>
                  <div className="customer-service">{f.service}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
